<div
    *ngIf="notifications?.length > 0; else nonotifications"
    class="notification-list-view-container"
    infiniteScroll
    [infiniteScrollContainer]="'.notification-list-view-container'"
    [fromRoot]="true"
    (scrolled)="onScrollDownThreshold()"
    [infiniteScrollThrottle]="50"
    [infiniteScrollDistance]="2">
    <div *ngFor="let notification of notifications">
        <app-notification-details
            [notification]="notification"
            (notificationViewEvent)="onViewNotification($event)"
            (toggleReadNotificationEvent)="
                toggleReadNotification($event)
            "></app-notification-details>
    </div>
</div>
<ng-container *ngIf="scrollLoading$ | async">
    <div class="scroll-loader-container">
        <mat-spinner diameter="20"></mat-spinner>
    </div>
</ng-container>

<ng-template #nonotifications>
    <div class="no-notifications-block">
        <div class="no-notifications-block-icon">
            <mat-icon class="no-notifications-block-icon__icon"
                >notifications_off</mat-icon
            >
        </div>
        <div class="icon_text">Currently you have no notifications.</div>
    </div>
</ng-template>
